// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: 6,
  }
};

// Declare Templates
var bcSfFilterTemplate = {
  'soldOutClass': 'sold-out',
  'saleClass': 'on-sale',
  'soldOutLabelHtml': '<div class="sold-out-overlay"><span><em>Sold Out</em></span></div>',
  'saleLabelHtml': '<div class="sale-label">' + bcSfFilterConfig.label.sale + '</div>',
  'vendorHtml': '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  'productGridItemHtml': '<li class="col-md-4 col-sm-6 col-xs-6 clearfix collection-prod {{itemHandle}}" id="collection-prod-item">' +
  '<div class="{{soldOutClass}} {{saleClass}}">' +                                    
  '<div class="">' +
  '{{itemSaleLabel}}' +
  '{{itemSoldOutLabel}}' +
  //'<div class="product-tag">{{itemtag}}</div>' + 
  '<div class="coll-image-wrap"><a href="{{itemUrl}}" class=""><img id="feImg{{itemId}}" src="{{itemThumbUrl}}" alt="{{itemTitle}}" /></a></div>' +
  '</div>' +
  '<div class="coll-prod-meta">'+
  '<div class="colorVariants"><ul>'+  
  '{{itemswatch}}'+  
  '</ul>'+
  '<div class="Variantsopt"><select class="product-select hidden" name="id">'+  
  '{{itemvar}}'+  
  '</select>'+
  '</div>'+
  '<div class="coll-prod-title"><a href="{{itemUrl}}" class="">{{itemTitle}}</a></div>' +
  '<div class="coll-prod-title">{{itemTags}}</div>' +
  '{{itemVendor}}' +  
  '<div class="coll-prod-price">{{itemPrice}}</div>' +  
  '</div>'+
  '</div>' +
  '</li>',
  
 

  // Pagination Template
  'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
  'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
  'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
  'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
  'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};
 

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
//console.log("DATA :: "+JSON.stringify(data));
  /*** Prepare data ***/
  var images = data.images_info;
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
 // var showtag;
  var var_data;
  var var_id;
  var var_qty;
  var var_opt;
  var optval;
  var colortitle;
  var col_swatch_options = [];
  var col_swatch_pro_imgs = [];
  var col_swatch_options = [];
  var tooltip_nm;
  var color_class_nm;
  var ava_cls;
  //var meta_arr = [];
  var swatchhtml;
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];              
        break;
      }
    }
  }
  /*** End Prepare data ***/

	 //For display tag
  /*for (var i = 0; i < data['tags'].length; i++) {
    if (data['tags'][i].includes('Fabric Technology:')){
      showtag = data['tags'][i];
      console.log("showtag :: "+showtag);
      var res = showtag.split(":").pop(-1) ;
    }
  }*/
  
    
  /* For display collection swatch */
 
  for (var i = 0; i < data['images'].length; i++) {   
    col_swatch_pro_imgs[data['images'][i].position] = data['images'][i].src;   
  }
   
  for (var i = 0; i < data['options_with_values'].length; i++) {  
    if (data['options_with_values'][i].name == "color"){      
      optval = data['options_with_values'][i].values; 
      for(var j = 0; j < optval.length; j++){
        colortitle = optval[j].title.toLowerCase().replace(/ - /g, '-');      
        colortitle = colortitle.replace(/ /g, '-');
        //console.log('1', optval[j].image);
        //console.log(col_swatch_pro_imgs);
        col_swatch_options[colortitle] = col_swatch_pro_imgs[optval[j].image];      
      }
    }
  } 
  
  
  var itemSwatchHtml = '';
  data.options_with_values.forEach(function (option) {
    var option_name = option.name.toLowerCase();
    if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
      var values = '';
      itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
      var i = 0;
      
      if (bcsffilter.queryParams.hasOwnProperty('pf_opt_size')) {
        var sizes = bcsffilter.queryParams.pf_opt_size;
        var colors = option.values;
        
        for (var j = 0; j < colors.length; j++) {
          var color = colors[j].title;
          var value = color.replace(/ - /g, '-') + '.png';
          var name_color = value.replace(/ /g, '-').toLowerCase();
          console.log("name_color1 ::"+name_color);
          tooltip_nm = name_color.replace('.png', ' ');
           //console.log("tooltip_nm ::"+tooltip_nm);
          tooltip_nm = tooltip_nm.replace(/-/g, ' ');
          var url_color = bcSfFilterMainConfig.general.asset_url.replace('bc-sf-filter.js', name_color);
          var variant = data.variants.find(function(e){return e.option_color == color && e.option_size ==sizes[0];});
          if (typeof variant != 'undefined' && variant.available) {
            itemSwatchHtml += '<li class="' + color.toLowerCase() + '">';
            itemSwatchHtml += '<a href="javascript:void(0)" class="swatch-clr" data-src="' + variant.image + '" data-pid="{{itemId}}" data-toggle="tooltip" data-placement="top" title="' + tooltip_nm + '">';
            itemSwatchHtml += '<img src="' + url_color + '" ><br>';
            itemSwatchHtml += '</a></li>';
          }
          //console.log(variant);
        }
        
      } else {
        data.variants.forEach(function (variant) {
        var temp = variant.merged_options.filter(function (obj) {
          obj = obj.toLowerCase();
          if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
            return obj;
        });
        temp = temp[0].split(':');
        var value = temp[1].toLowerCase();
        
        if (values.indexOf(value) == -1 && variant.hasOwnProperty('image') && variant.available) {
          //console.log(variant);
          if ( variant.image != null ){
          values = values + ',' + value;
          values = values.split(',');
         
          var value = value.replace(/ - /g, '-') + '.png';
          var name_color = value.replace(/ /g, '-');
          console.log("name_color2 ::"+name_color);
          tooltip_nm = name_color.replace('.png', ' ');
            color_class_nm = name_color.replace('.png', ' ')
           console.log("tooltip_nm ::"+tooltip_nm);
          tooltip_nm = tooltip_nm.replace(/-/g, ' ');
         //console.log("tooltip_nm ::"+tooltip_nm);
          var url_color = bcSfFilterMainConfig.general.asset_url.replace('bc-sf-filter.js', name_color);
            itemSwatchHtml += '<li class="' + color_class_nm +'">';
            itemSwatchHtml += '<a href="javascript:void(0)" class="swatch-clr" data-src="' + variant.image + '" data-pid="{{itemId}}" data-toggle="tooltip" data-placement="top" title="' + tooltip_nm + '">';
            itemSwatchHtml += '<img src="' + url_color + '" ><br>';
            itemSwatchHtml += '</a></li>';
          
          i++;
            
          }
        }
      });
      }
      
      itemSwatchHtml += '</div>';
    }
  });
  
  
  
  var manual_variant_structure = '';
  
  for (var i = 0; i < data['variants'].length; i++) {
    var_opt = data['variants'][i]; 
    // console.log(data['variants'][i]);  
    var var_title = var_opt.title.split(" / ");
    var firstName = var_title[0].toLowerCase().replace(/ /g, '-');;
    var lastName = var_title[1];
    if(var_opt.available){
      ava_cls = 'available'; 
    }
    else{
      ava_cls = 'soldout';
    }
    manual_variant_structure += '<option class="'+firstName+'-'+lastName+'-'+ava_cls+'">'+
      var_opt.title+
      '</option>';
  }
  
  /*jQuery("body").on("click",".bc-sf-filter-option-block-size ul.bc-sf-filter-option-box li a", function(){
    var variant_size = $(this).attr("data-title");
    $(".colorVariants ul li").hide();
   // console.log("variant_size :: "+variant_size);   
  });*/
  
  
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  //Add Tag

  //itemHtml = itemHtml.replace(/{{itemtag}}/g, res);  
  itemHtml = itemHtml.replace(/{{itemswatch}}/g, itemSwatchHtml);
  itemHtml = itemHtml.replace(/{{itemvar}}/g, manual_variant_structure);
  //itemHtml = itemHtml.replace(/{{itemmeta}}/g, manual_meta_structure);
     

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Price
  var itemPriceHtml = '';
  if (data.title != '')  {
    itemPriceHtml += '<p class="grid-link__meta">';
    if (onSale) {
      itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
    }
    if (priceVaries) {
      //itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
      itemPriceHtml += this.formatMoney(data.price_min);
    } else {
      itemPriceHtml += this.formatMoney(data.price_min);
    }
    itemPriceHtml += '</p>';
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
  
  var itemTags = '';
  if (data.tags) {
    var activity = '',
        from = '';
    for (var i = 0; i < data.tags.length; i++) {
      var tag = data.tags[i];
      if (tag.indexOf('Fabric Technology:') > -1) {
        from = tag.replace('Fabric Technology:', '');
      }
      if (tag.indexOf('Activity:') > -1 && i < 2) {
        activity += tag.replace('Activity:', '');
        if (i < 1) {
          activity += ', ';
        }
      }
    }
    itemTags += '<div class="coll-prod-title">Made from ' + from + '</div>';
  	itemTags += '<div class="coll-prod-title">Recommended for ' + activity + '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemTags}}/g, itemTags);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
 // itemHtml = itemHtml.replace(/{{itemtag}}/g, data.tags); 
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('');
      return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content 
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  $('[data-toggle="tooltip"]').tooltip();  

  collectionVideo();  
  $(window).resize(function(){
    collectionVideo();
  });
  
  $('.selected-type').each(function() {
    $(this).html($(this).html().replace(":", ""));
  });
  
  jQuery('.bc-sf-filter-option-single-list li').each(function(){  
   var cat_text = $(this).find(".bc-sf-filter-option-value").text(); 
  });
  
  
    jQuery("body").on("click",".bc-sf-filter-option-block-category .bc-sf-filter-option-single-list li a", function(){
      var cat_nm = $(this).find(".bc-sf-filter-option-value").text();      
      $(".collection_content_product_listing .breadcrumb .cat-title").text(cat_nm);
      $(".collection_content_product_listing .coll-title").text(cat_nm);
      collectionVideo(); 
      $(window).resize(function(){
      collectionVideo();
      }); 
    });
  
   jQuery('#collection-prod-item .money').each(function(){         
          var tempvarr = jQuery(this).text();
          var ress = tempvarr.split("."); 
          // var final = "<sup>"+ress[0]+".</sup> "+ress[1];
          var final = ress[0]+"."+ress[1];  
     		final = final.replace(",", "")
          jQuery(this).html(final);
        });

  /*jQuery("body").on("click",".bc-sf-filter-option-block-size ul.bc-sf-filter-option-box li a", function(){
    var variant_size = $(this).attr("data-title");
    $(".colorVariants ul li").hide();
    console.log("variant_size :: "+variant_size);   
  });*/
};

BCSfFilter.prototype.buildFilterSelection = function(data) {
    var selectionContent = this.buildFilterSelectionData(data);
  	if (jQ('.bc-sf-filter-selection-wrapper').length > 0) {
      	jQ('.bc-sf-filter-selection-wrapper').remove();
    }
    if (selectionContent !== '') {
        // Build the selection block base on above content
        var selectionWrapperHtml = this.getTemplate('filterRefineWrapper');
        selectionWrapperHtml = selectionWrapperHtml.replace(/{{label.refine}}/g, this.getSettingValue('label.refine'));
        selectionWrapperHtml = selectionWrapperHtml.replace(/{{selectedItems}}/g, selectionContent);
        selectionWrapperHtml = selectionWrapperHtml.replace(/{{clearAllButton}}/g, this.buildClearAllButton());
        selectionWrapperHtml = this.buildFilterTreeClass(selectionWrapperHtml);
        // for (var k = 1; k <= this.getSettingValue('general.numberFilterTree'); k++) {
        //     var filterTreeId = k == 1 ? '' : k;
        //     this.addFilterTreeItem(selectionWrapperHtml, 'before', filterTreeId);
        // }
      	jQ(selectionWrapperHtml).insertBefore('#bc-sf-filter-tree-mobile');
    }
};
BCSfFilter.prototype.afterBuildFilterTree = function(data, filterTreeId) {
    // Wrap all filter option blocks for styling
    jQ(this.getSelector('filterTree') + filterTreeId).children().wrapAll('<div id="bc-sf-filter-options-wrapper"></div>');
    // Box Style
    this.buildFilterOptionBoxStyle(null, filterTreeId);
    // Add scroll bar for block has long content, except the filter option which is range
    this.buildFilterShowMore();
    // Collapse all filter options by default
    if (!this.checkIsFullWidthMobile()) this.collapseFilterOption();

    // Hide filter tree and fix the product list style when the filter has no data
    this.buildFilterTreeStyleNoFilterData(data, filterTreeId);
  
  	if (this.isMobile() && this.isMobileDevice()) {
      	jQ('#bc-sf-filter-tree-mobile').wrap('<div class="contain-mobile"></di>');
      	jQ('.contain-mobile').find('.bc-sf-filter-option-block-category').remove();
      	var html = jQ('.bc-sf-filter-option-block-category').detach();
      	html.insertAfter('#bc-sf-filter-tree-mobile');
      	jQ('.bc-sf-filter-option-block-category').addClass('border-bottom');
    }
  
  	
};

BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var _this = this;
    var filterSelector = this.getSelector('filterTree');
    var mobileBtnSelector = this.getSelector('filterTreeMobileButton');
    jQ(mobileBtnSelector).unbind('click');
    jQ(mobileBtnSelector).on('click', function() {
        var style = _this.mobileStyle;
        // Full Width style
        if (style == 'style2' || style == 'style3') {
            jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
            // Build mobile content
            _this.buildFilterTreeMobile();
            // Remove scrollbar
            _this.removeScrollbar(jQ('.' + _this.class.filterBlockContent));
        }
        // Default style
        else {
            // Change button text when clicking
            if (_this.getSettingValue('general.changeMobileButtonLabel')) {
                var openClass = _this.class.mobileButtonOpen;
                jQ(this).toggleClass(openClass);
                var label = jQ(this).hasClass(openClass) ? _this.getSettingValue('label.refineMobileCollapse') : _this.getSettingValue('label.refineMobile');
                jQ(this).text(label);
            }
            jQ(filterSelector).slideToggle(function () {
                jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
                _this.buildFilterOptionBoxStyle(jQ(this));                
                // Re-initialize jscrollpane
                _this.buildFilterScrollbar();
            });
          
          	if (!jQ('.bc-sf-filter-option-block-category .bc-sf-filter-block-title span').hasClass('up')){
              jQ('.bc-sf-filter-option-block-category .bc-sf-filter-block-title span').addClass('up');
              jQ('.bc-sf-filter-option-block-category').addClass('border-bottom');
              jQ('.bc-sf-filter-option-block-category .bc-sf-filter-block-content').slideUp();
              
            }
        }
    });
};

BCSfFilter.prototype.buildToggleEvent = function(data) {
    var self = this;
    var openListClass = this.class.filterOptionOpenList,
        closeListClass = this.class.filterOptionCloseList,
        filterOptionClass = this.class.filterOption;
    var openList = jQ('.' + openListClass).length > 0 ? jQ('.' + openListClass).val().split(',') : [];
    var closeList = jQ('.' + closeListClass).length > 0 ? jQ('.' + closeListClass).val().split(',') : [];
    jQ('.' + this.class.filterBlockTitle + ' h3').on('click', function(e) {
        e.preventDefault();
        var filterOptionId = jQ(this).closest('.' + filterOptionClass).attr('data-id');
        // Open state
        if (jQ(this).children().hasClass('up')) {
          	
          
            if (self.getSettingValue('general.keepToggleState')) {
                openList.push(filterOptionId);
                if (closeList.length > 0 && closeList.indexOf(filterOptionId) > -1) {
                    closeList.splice(closeList.indexOf(filterOptionId), 1);
                }
            }
            jQ(this).children().removeClass('up');
          	if (jQ(this).parents('.bc-sf-filter-option-block').hasClass('bc-sf-filter-option-block-category')) {
                jQ('.bc-sf-filter-option-block-category').removeClass('border-bottom');
            }
            jQ(this).parent().siblings().slideDown(function() {
                if (jQ(this).parent().attr('data-display-type') != 'range') {
                  	if (!jQ(this).parents('.bc-sf-filter-option-block').hasClass('bc-sf-filter-option-block-category')) {
                        self.buildFilterOptionBoxStyle(jQ(this));
                    		self.buildFilterScrollbar(this);
                    }	else {
                      	jQ('.bc-sf-filter-option-block-category .bc-sf-filter-block-title span').removeClass('up');
                      	jQ('.bc-sf-filter-option-block-category').removeClass('border-bottom');
                      	bcsffilter.removeScrollbar(jQ('.bc-sf-filter-option-block-category .bc-sf-filter-block-content'));
                      	$('.bc-sf-filter-option-block-category .bc-sf-filter-block-content').removeAttr('style');
                    }                    
                }
            });
          
          	if (jQ(this).parents('.bc-sf-filter-option-block').hasClass('bc-sf-filter-option-block-category')) {
              	if (jQ('#bc-sf-filter-tree-mobile-button').hasClass('bc-sf-filter-tree-mobile-button-open')) {
                  	jQ('#bc-sf-filter-tree-mobile-button').trigger('click');
                }
            }
        }
        // Collapse state
        else {
            if (self.getSettingValue('general.keepToggleState')) {
                closeList.push(filterOptionId);
                if (openList.length > 0 && openList.indexOf(filterOptionId) > -1) {
                    openList.splice(closeList.indexOf(filterOptionId), 1);
                }
            }
            jQ(this).children().addClass('up');
            if (jQ(this).parents('.bc-sf-filter-option-block').hasClass('bc-sf-filter-option-block-category')) {
                jQ('.bc-sf-filter-option-block-category').addClass('border-bottom');
            }
            jQ(this).parent().siblings().slideUp(function(){
              	// if (jQ(this).parents('.bc-sf-filter-option-block').hasClass('bc-sf-filter-option-block-category')) {
              	// jQ('.bc-sf-filter-option-block-category').addClass('border-bottom');
              	// }
            });
        }
        jQ('.' + openListClass).val(openList.join(','));
        jQ('.' + closeListClass).val(closeList.join(','));
      
      	
    });

    if (this.getSettingValue('general.collapseSubCategory')) {
        jQ('.' + this.class.filterOption + '.bc-sf-filter-option-block-sub_category .bc-sf-filter-option-single-list li span.sub-icon').on('click', function(e) {
            if (jQ(this).hasClass('sub-up')) {
                jQ(this).removeClass('sub-up');
                jQ(this).parent().siblings().slideDown();
            } else {
                jQ(this).addClass('sub-up');
                jQ(this).parent().siblings().slideUp();
            }
        });
    }
};




// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

function collectionVideo(){
  console.log("collectionvideo...");
  var pageURL = $(location).attr("href");
  var collHandle = pageURL.substring(pageURL.lastIndexOf('/') + 1);
  var splitvalue="";
  var splitvalue1="";
  var collvideodeskhtml = "";
  console.log(collHandle);

  videocollArr.forEach(function(item, index) {
    if(item.indexOf(collHandle) != -1) {     
      if(item.indexOf(collHandle+"_desk") != -1) {
        console.log("item :: "+item);
        splitvalue = item.split("_")[2]; 
        console.log("splitvalue1 = "+splitvalue);
      }
      if(item.indexOf(collHandle+"_mob") != -1) {
        console.log("item :: "+item);
        splitvalue1 = item.split("_")[2];          
      }
    }    
    });
  
    if($(window).width() > 767){
      console.log("width>767");
      console.log("splitvalue = "+splitvalue);
      if(splitvalue != ""){
        
        collvideodeskhtml = '<div class="disktop-video"><div class="video-wrappers"><video class="hidden-xs" id="myVideo1" width="100%" height="100%" playsinline="" autoplay="" loop="" muted controls="true"><source src="'+splitvalue+'" type="video/mp4" /></video></div></div>'
        $(".collection-video").html(collvideodeskhtml);
      }
      else{
        $(".collection-video").html("");
      }
    }
    else{
      if(splitvalue1 != ""){
        collvideodeskhtml = '<div class="disktop-video"><div class="video-wrappers"><video class="hidden-sm hidden-md hidden-lg" id="myVideo1" width="100%" height="100%" playsinline="" autoplay="" loop="" muted controls="true"><source src="'+splitvalue1+'" type="video/mp4" /></video></div></div>'
        $(".collection-video").html(collvideodeskhtml);
      }
      else{
        $(".collection-video").html("");
      } 
    }  
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
